import type { HotelsLocale } from './en'

export const hotelsEs = {
  nav: {
    dashboard: 'Panel',
    settings: 'Configuración',
    wakeupScheduling: 'Programación de despertador',
    wakeupHistory: 'Historial de despertador',
  },
  common: {
    unknown: 'Desconocido',
    notAvailable: 'N/D',
    placeholder: '—',
    search: 'Buscar',
    entries: 'entradas',
    show: 'Mostrar',
    retry: 'Intentar de nuevo',
    loading: 'Cargando',
    previous: 'Anterior',
    next: 'Siguiente',
    dayPlaceholder: 'Día...',
    timePlaceholder: 'Hora...',
    filterTimesPlaceholder: 'Filtrar horas...',
  },
  dialogs: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
  },
  errors: {
    loadRooms: 'No se pudieron cargar las habitaciones',
    loadWakeupHistory: 'No se pudo cargar el historial de despertadores',
    loadPbxSettings: 'No se pudo cargar la configuración de PBX',
    loadExtensions: 'No se pudieron cargar las extensiones',
  },
  pagination: {
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
    resultsPerPage: 'Resultados por página:',
    all: 'Todos',
    jumpToPage: 'Ir a la página {{page}}',
    recordRange: '{{start}}—{{end}} de {{total}}',
    recordRangeEmpty: '0 de 0',
  },
  tableToolbar: {
    entriesOnly: '{{count}} entradas',
    entriesFiltered: '{{filtered}} de {{total}} entradas',
    resultsPerPage: 'Resultados por página:',
    showingSummary: 'Mostrando {{start}}-{{end}} de {{count}}',
  },
  datePresets: {
    today: 'Hoy',
    tomorrow: 'Mañana',
    yesterday: 'Ayer',
    '1week': '1 semana',
    '2weeks': '2 semanas',
    '3weeks': '3 semanas',
    '4weeks': '4 semanas',
    all: 'Todos',
  },
  wakeupStatus: {
    scheduled: 'Programado',
    tried: 'Intentado',
    cleared: 'Borrado',
    canceled: 'Cancelado',
  },
  dashboard: {
    incomingCallHistory: 'Historial de llamadas entrantes',
    emergencyHistory: 'Historial 911 (7 días)',
    roomStatus: 'Estado de habitaciones',
    searchCalls: 'Buscar llamadas...',
    noIncomingCalls: 'No hay llamadas entrantes',
    noMatchingCalls: 'Ninguna llamada coincide con tu búsqueda',
    number: 'Número',
    name: 'Nombre',
    time: 'Hora',
    destination: 'Dest.',
    room: 'Habitación',
    timeAndDate: 'Hora y fecha',
    duration: 'Duración',
    noEmergencyCalls: 'Sin llamadas',
    emergencyFooter: '* Llamada realizada al {{destination}}',
    refreshingIn: 'Actualizando en {{seconds}}s',
    noRoomsTitle: 'No se encontraron habitaciones',
    noRoomsDescription:
      'No hay habitaciones de hotel configuradas para esta PBX.',
    resetRoomsSuccess: '{{count}} habitaciones restablecidas a Sucia',
    resetRoomsFailed: 'No se pudieron restablecer las habitaciones',
    roomStatusActions: {
      dirty: 'Sucia',
      clean: 'Limpia',
      occupied: 'Ocupada',
      inspected: 'Inspeccionada',
    },
    roomTile: {
      openAria: 'Abrir habitación {{room}}',
    },
    roomDetail: {
      title: 'Habitación {{room}}',
      changeStatus: 'Cambiar estado',
      cleanOrInspectedWarning:
        'Cambiar a Limpia o Inspeccionada cancelará los despertadores activos y borrará los buzones de voz.',
      activeWakeups: 'Despertadores activos',
      voicemails: 'Buzones de voz',
      statusUpdated: 'Estado de la habitación actualizado',
      statusUpdateFailed: 'No se pudo actualizar el estado de la habitación',
    },
    resetAllRooms: {
      button: 'Restablecer todas las habitaciones a Sucia',
      title: 'Restablecer todas las habitaciones',
      description:
        'Esto pondrá todas las habitaciones en estado Sucia. Los despertadores y buzones de voz no se verán afectados. ¿Seguro?',
      confirm: 'Restablecer todo',
    },
    wakeupPopover: {
      title: 'Despertadores',
      manageAria: 'Administrar despertadores',
      manageAriaPending: 'Administrar despertadores (pendientes)',
      manageAriaCleared: 'Administrar despertadores (borrados)',
      clearAll: '¿Borrar todo?',
      clearAllSuccess: '{{count}} despertador{{suffix}} cancelado',
      clearAllFailed: 'No se pudieron borrar los despertadores',
      scheduleSuccess: 'Despertador programado',
      scheduleFailed: 'No se pudo programar el despertador',
      addAria: 'Agregar despertador',
      loading: 'Cargando...',
      none: 'No hay despertadores activos',
      schedule: 'Programación',
      cancelAria: 'Cancelar despertador',
      cancelAriaWithTime: 'Cancelar despertador de las {{time}}',
    },
    voicemailPopover: {
      title: 'Buzones de voz',
      manageAria: 'Administrar buzones de voz',
      manageAriaWithCount_one:
        'Administrar buzones de voz ({{count}} mensaje de voz)',
      manageAriaWithCount_other:
        'Administrar buzones de voz ({{count}} mensajes de voz)',
      clearAll: '¿Borrar todo?',
      clearAllSuccess_one: 'Se borró {{count}} mensaje de voz',
      clearAllSuccess_other: 'Se borraron {{count}} mensajes de voz',
      clearAllFailed: 'No se pudieron borrar los buzones de voz',
      loading: 'Cargando...',
      none: 'No hay buzones de voz',
      status: 'Estado',
      received: 'Recibido',
      from: 'De',
      read: 'Leído',
      new: 'Nuevo',
      deleteAria: 'Eliminar buzón de voz',
      deleteSuccess: 'Buzón de voz eliminado',
      deleteFailed: 'No se pudo eliminar el buzón de voz',
    },
  },
  wakeupScheduler: {
    scheduleSuccess: '{{count}} despertador{{suffix}} programado',
    scheduleFailed: 'No se pudieron programar los despertadores',
    selectDate: 'Seleccionar fecha',
    selectTime: 'Seleccionar hora',
    scheduleWakeupCalls: 'Programar despertadores',
    scheduling: 'Programando...',
    selectedRooms: '{{count}} habitación{{suffix}} seleccionada',
    cancelSuccess: 'Despertador cancelado',
    cancelFailed: 'No se pudo cancelar el despertador',
    addToPendingAria: 'Agregar a cambios pendientes',
    pendingChanges: 'Cambios pendientes',
    noPendingChanges: 'Aún no hay cambios pendientes',
    applyChanges: 'Aplicar cambios',
    reset: 'Restablecer',
    noMatchingRooms: 'No hay habitaciones coincidentes',
    noRoomsAvailable: 'No hay habitaciones disponibles',
    roomNumber: 'Número de habitación',
    roomName: 'Nombre de habitación',
    status: 'Estado',
    currentSchedule: 'Programación actual',
    selectAllRooms: 'Seleccionar todas las habitaciones',
    selectRoom: 'Seleccionar habitación {{number}}',
    dayLabel: 'Día',
    timeLabel: 'Hora',
    filterTimesLabel: 'Filtrar horas',
    removePendingAria:
      'Quitar despertador pendiente de la habitación {{room}}, {{time}}',
    cancelWakeupAria:
      'Cancelar despertador de la habitación {{room}} de las {{time}}',
  },
  history: {
    noHistory: 'No hay historial de despertadores',
    noMatchingRecords: 'No se encontraron registros coincidentes',
    showing: 'Mostrando {{start}} a {{end}} de {{count}} entradas',
    filteredFromTotal: '(filtrado de {{total}} entradas totales)',
    room: 'Habitación',
    roomName: 'Nombre de habitación',
    attempts: 'Intentos',
    wakeupDateTime: 'Fecha y hora de despertador',
    activationDateTime: 'Fecha y hora de activación',
    wakeupStatus: 'Estado del despertador',
    originator: 'Originador',
    originPhone: 'Teléfono',
    originPortal: 'Portal',
  },
  settings: {
    activation: 'Activación',
    searchRoomsOrNames: 'Buscar por habitación o nombre...',
    noMatchingExtensions: 'Ninguna extensión coincide con tu búsqueda',
    noExtensionsForPbx: 'No se encontraron líneas de extensión para esta PBX',
    active: 'Activo',
    roomNumber: 'Número de habitación',
    extensionName: 'Nombre de extensión',
    currentStatus: 'Estado actual',
    roomActiveAria: 'Habitación {{number}} activa',
    statusAtTime: '{{status}} ({{time}} - {{date}})',
    activated: 'activada',
    deactivated: 'desactivada',
    roomToggleStatus: 'Habitación {{roomNumber}} {{action}}',
    toggleHospitalityFailed: 'No se pudo cambiar el modo hotelero',
    resetRoomsToDirty: 'Restablecer habitaciones a Sucia',
    everyDayAt: 'Todos los días @',
    manually: 'Manualmente',
    saveSchedule: 'Guardar',
    scheduleSaveFailed: 'No se pudo actualizar el horario de restablecimiento',
    manualResetEnabled:
      'El estado de las habitaciones se restablecerá manualmente',
    dailyResetAt:
      'El estado de las habitaciones se restablecerá diariamente a las {{time}}',
  },
} satisfies HotelsLocale
